import React from 'react';
import type { ButtonProps } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as S from './styles';

type DownloadButtonProps = ButtonProps & {
	onClick?: () => void;
	children?: React.ReactNode;
	showIcon?: boolean;
};

export function DownloadButton({ children = '', onClick, showIcon = true, ...props }: Readonly<DownloadButtonProps>) {
	return (
		<S.DownloadButton
			{...props}
			onClick={onClick}
			icon={showIcon && <DownloadOutlined style={{ color: '#2F54EB' }} />}
		>
			{children}
		</S.DownloadButton>
	);
}
